import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { ToasterService } from '../../providers/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toasterService: ToasterService
  ) {}

  getAllBadges(): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/badges/get-all`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  getAllCertificates(): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/certificate/get-all`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  createBadge(data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        let reqHeaders = headers;
        if (data instanceof FormData) {
          reqHeaders = reqHeaders.delete('Content-Type');
        }
        return this.http.post(`${this.apiUrl}master/badges/create`, data, {
          headers: reqHeaders,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  createCertificate(data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        let reqHeaders = headers;
        if (data instanceof FormData) {
          reqHeaders = reqHeaders.delete('Content-Type');
        }
        return this.http.post(`${this.apiUrl}master/certificate/create`, data, {
          headers: reqHeaders,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  updateBadge(id: number | string, data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        let reqHeaders = headers;
        if (data instanceof FormData) {
          reqHeaders = reqHeaders.delete('Content-Type');
        }
        return this.http.post(`${this.apiUrl}master/badges/update/${id}`, data, {
          headers: reqHeaders,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  updateCertificate(id: number | string, data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        let reqHeaders = headers;
        if (data instanceof FormData) {
          reqHeaders = reqHeaders.delete('Content-Type');
        }
        return this.http.post(`${this.apiUrl}master/certificate/update/${id}`, data, {
          headers: reqHeaders,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  deleteBadge(id: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/badges/${id}/delete`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  deleteCertificate(id: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/certificate/${id}/delete`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  getCertificateById(id: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/certificate/${id}`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  getBadgeById(id: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/badges/${id}`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  private handleTokenExpired(): void {
    this.toasterService.setToaster(
      'default',
      'Session Expired',
      'The session has expired. Please log in again.'
    );
    this.authService.logout();
  }

}
